/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Stack } from 'sarsaparilla';
import HolderForm from './HolderForm';

export default function Holders({ errors, onChangeHandler, reservations }) {
    const hasReservations = !!reservations.length;

    if (!hasReservations) {
        return null;
    }

    return (
        <div className="ia-holders">
            <Stack>
                <Heading headingLevel={3} appearance="h5" className="ia-holders-title">
                    Enter Pass Details
                </Heading>
                <div className="ia-holders-description">
                    <p>Please provide the the required information below:</p>
                </div>
                {reservations.map((item, index) => {
                    return (
                        <div className="ia-holders-item" key={`ia-holders-item-${index}`}>
                            <div className="ia-holders-item-header">
                                <Heading
                                    headingLevel={3}
                                    appearance="h6"
                                    className="ia-holders-item-title"
                                >
                                    {item?.pass_type?.name}
                                </Heading>
                            </div>
                            <div className="ia-holders-item-body">
                                <HolderForm
                                    key={`holder-form-${item?.pass_type?.id}`}
                                    errors={errors[item?.pass_type?.name] || []}
                                    index={index}
                                    onChangeHandler={onChangeHandler}
                                    reservation={item}
                                />
                            </div>
                        </div>
                    );
                })}
            </Stack>
        </div>
    );
}

Holders.propTypes = {
    errors: PropTypes.object.isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    reservations: PropTypes.array.isRequired,
};
